import { Component } from "react";
import { connect } from "react-redux";
import "firebase/auth";
import { History } from "history";
import queryString from "querystring";
import once from "lodash/once";
import { GoogleSheetsSource, isAppID, isSheetSourceSignInFailure } from "../../lib/google-sheets-source";
import { makeAppFromSource } from "../../lib/app-rendering";
import {
    UserDataAndState,
    isUserData,
    isSizeLimitException,
    makeAppFeatures,
    loadNewFeatures,
    saveNewestFeatureSeen,
    Organization,
    getAppEminenceFlags,
    UserData,
} from "common/Database";
import { getAppFacilities } from "webapp/lib/app-renderer";
import * as actions from "../../actions/actions";
import * as appsActions from "../../actions/apps-actions";
import {
    RootState,
    SourcePadState,
    AppsAndState,
    TileDescriptionsState,
    OrganizationsState,
    getAppEminenceFlagsFromState,
    getAppOwner,
} from "../../store/types";
import * as userReducer from "../../reducers/user-data";
import * as userActions from "../../actions/user-actions";
import * as organizations from "../../reducers/organizations";
import * as routes from "../../routes";
import ActionModal from "../modals/smart/action-modal/action-modal";
import { logInfo, logError } from "common/debug-print";
import { showSharedDriveNeedsProModal, showBasicActionModal } from "../ui/smart/modals/modals";
import { ModalBody } from "../modals-v2/modal-v2-common-styles";
import { makeAppEnvironmentForAppDescription } from "../../lib/make-env";
import {
    getAppFeatures,
    AppAuthenticationKind,
    getGoogleSheetsSourceMetadata,
    getSerializedAppSchema,
    AppAuthentication,
    newAppNonUserAppFeatures,
    AuthenticationEmailSource,
    AppKind,
} from "common/components/SerializedApp";
import {
    parseAnonymousUserID,
    isResponseOK,
    assertNever,
    checkString,
    dontAwait,
    getResponseErrorMessage,
} from "common/Support";
import WhatsNewModal from "../modals/views/whats-new-modal/whats-new-modal";
import { ActionStatus } from "./lib/action-status";
import { SignInUpModal, showSignUpPopupBlockedFlow } from "../modals/smart/sign-in-up-modal/sign-in-up-modal";
import { onAuthStateChanged } from "../../lib/firebase-auth";
import {
    DuplicateAppBody,
    TransferAppToOrganizationResponse,
    InviteUserToTransferAppBody,
    MakeSupportCodeForAppBody,
    NewGlideTableAppBody,
    NewAppSurveyData,
} from "common/firebase-function-types";
import { getAuth2, googleConnectionFailureMessage } from "../../lib/google-api";
import { createBuilderApp } from "common/save-builder-app";
import { FirebaseAppUserAuthenticator } from "sharedUI/lib/app-user-authenticator";
import { trackEvent } from "../../analytics";
import { Switch, Route, RouteComponentProps, withRouter, Redirect } from "react-router-dom";
import OverviewScreen from "./orgs/overview-screen/overview-screen";
import BillingScreen from "./orgs/billing-screen/billing-screen";
import ReferralScreen from "./orgs/referral-screen/referral-screen";
import MembersScreen from "./orgs/members-screen/members-screen";
import OrgsScreen from "./orgs/orgs-screen/orgs-screen";
import { Icon } from "common/render/icon";
import { removeQueryStrings } from "../../lib/browser-hacks";
import MobileOverviewScreen from "./orgs/mobile-overview-screen/mobile-overview-screen";
import { signInToFirebaseWithCustomToken } from "webapp/lib/auth";
import { clearUndo } from "../../lib/undo";
import { getLocationSettings } from "../../lib/location";
import { finishOnboarding, transferAppToOrganization } from "../../lib/firebase-functions";
import { getBuilderAppDatabase, getBuilderUserDatabase } from "../../lib/web-database";
import { Eminence, EminenceFlags, TransferToOrgAs } from "common/Database/eminence";
import { evaluateApp } from "../../lib/build-and-evaluate";
import { TileDescription } from "../../common/Database/tile-type";
import { MappedThunk } from "../../actions/action-thunk";
import { confirmProUpgrade } from "analytics/upgrades-by-quotas";
import { browserOnPhone } from "lib/browser-detect";
import InviteUserToAppModal from "designer/apps/ui/smart/invite-user-to-app-modal/invite-user-to-app-modal";
import { BuilderAction } from "common/Database/builder-actions";
import { startBusy, stopBusy } from "designer/designer";
import { makeRandomAppSettings } from "common/generator/screens";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { OwnerKind } from "common/Database/owner-kind";
import { hasOwnProperty } from "collection-utils";
import AcceptTeamInvite from "./ui/smart/accept-team-invite";

import { previewCharge } from "./orgs/orgs-lib";
import { setAppEnvironmentForAppID } from "sharedUI/app-state-context";

import {
    AppDuplicationError,
    GenericOhSheetError,
    InviteUserError,
    SignInError,
    SupportLinkCreateError,
    UnpublishDeleteAppError,
    TransferAppError,
} from "designer/modals-v2/modal-snippet-library";
import { OnboardingStyle } from "designer/modals-v2/new-team/onboarding-style";
import OnBoarding from "./ui/smart/new-team-flow/onboarding";
import { handleFirstTermsOfService } from "designer/lib/terms-of-service";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";
import WindowedModalV2 from "designer/modals-v2/windowed-modal/windowed-modal";
import { SupportModal } from "designer/modals/views/support-modal/support-modal";
import { DuplicateAppModal, DuplicateMethod } from "designer/modals/smart/duplicate-app-modal/duplicate-app-modal";
import { ThirdPartyCookiesModal } from "designer/modals/views/third-party-cookies-modal.tsx/third-party-cookies-modal";
import { showUpgradeModal } from "designer/builder/ui/smart/unified-app-plan/app-settings-plan-controller";
import { CardState, getCardState } from "designer/builder/ui/smart/unified-app-plan/app-settings-plan-lib";

interface Props extends RouteComponentProps<routes.OrgPatternRouteProps> {
    userData: UserDataAndState;
    organizations: OrganizationsState;
    apps: AppsAndState;
    tiles: TileDescriptionsState;
    setApp: typeof appsActions.setApp;
    unloadApps: typeof appsActions.unloadApps;
    removeAppFromUser: typeof userReducer.deleteApp;
    removeAppFromOrganization: typeof organizations.removeAppFromOrganization;
    loadAppAnalyticsForApp: MappedThunk<typeof actions.loadAppAnalyticsForApp>;
    loadZapierAPIKeyForApp: MappedThunk<typeof actions.loadZapierAPIKeyForApp>;
    addAppToOwner: MappedThunk<typeof actions.addAppToOwner>;
    setAppTitle: MappedThunk<typeof actions.setAppTitle>;
    setUserFlags: MappedThunk<typeof actions.setUserFlags>;
    setLastAcceptedTermsOfService: MappedThunk<typeof userActions.setLastAcceptedTermsOfService>;
    signOut: MappedThunk<typeof actions.signOut>;
    history: History;

    readonly modals: SimpleModalContextProps;
}

interface State {
    loadFeatureSettingsRetryCount: number;
    creatingAppText: string | undefined;
    shownLatest: boolean;
    actionStatus: ActionStatus;
    shouldPerformCopy: boolean;
    showSimpleInfoModal: boolean;
}

class Apps extends Component<Props, State> {
    private readonly forceSignInMode = queryString.parse(window.location.search.substr(1)).signIn !== undefined;

    public state: State = {
        loadFeatureSettingsRetryCount: 0,
        creatingAppText: undefined,
        shownLatest: false,
        actionStatus: ActionStatus.Idle,
        shouldPerformCopy: false,
        showSimpleInfoModal: true,
    };

    private terribleHackToSetAppKind: AppKind = AppKind.App;

    private showThirdPartyCookiesModal = () => {
        return this.props.modals.showModal<void>(resolve => {
            return <ThirdPartyCookiesModal resolve={resolve} />;
        });
    };

    private _googleSheetsSource = new GoogleSheetsSource(
        async (appID, organizationID, sourcePad, preferredFormFactor, appName) =>
            await this.setSheetSource(appID, organizationID, sourcePad, appName, preferredFormFactor),
        this.showThirdPartyCookiesModal
    );

    private getEminenceFlags(appID: string): EminenceFlags {
        return getAppEminenceFlagsFromState(appID, {
            userData: this.props.userData,
            apps: this.props.apps,
            organizations: this.props.organizations,
        });
    }

    private async setSheetSource(
        appID: string,
        organizationID: string | undefined,
        sourcePad: SourcePadState,
        appTitle: string | undefined,
        preferredFormFactor: string
    ): Promise<void> {
        const { userData } = this.props;
        let authentication: AppAuthentication | undefined;
        if (organizationID !== undefined) {
            authentication = {
                kind: AppAuthenticationKind.EmailPin,
                source: AuthenticationEmailSource.OrgMembers,
            };
        }
        const serializedApp = makeAppFromSource(
            appID,
            sourcePad,
            appTitle,
            authentication,
            // NOTE: This is where you set the app kind
            makeAppFeatures(userData, appID, false, undefined, newAppNonUserAppFeatures, this.terribleHackToSetAppKind),
            this.getEminenceFlags(appID)
        );
        if (serializedApp === undefined) return;

        if (!isUserData(userData)) {
            logInfo("no user data");
            return;
        }

        const appFacilities = getAppFacilities();
        await createBuilderApp(getBuilderAppDatabase(appID), serializedApp, appID, userData.id);
        const appEnvironment = makeAppEnvironmentForAppDescription(
            serializedApp,
            getSerializedAppSchema(serializedApp),
            new FirebaseAppUserAuthenticator(appFacilities, appID),
            makeAppFeatures(userData, appID, false, undefined, getAppFeatures(serializedApp), undefined),
            true
        );

        const builderActions = new Map<string, BuilderAction>();
        const appState = evaluateApp(appEnvironment, serializedApp, builderActions, sourcePad.schema);

        this.props.addAppToOwner(appID, organizationID);
        setAppEnvironmentForAppID(appID, appEnvironment);
        this.props.setApp(appID, {
            sourcePad,
            serializedApp,
            builderActions,
            appState,
            reloadIssues: undefined,
            publishState: {
                publishing: false,
                appURL: undefined,
                error: undefined,
                shortName: undefined,
                customDomain: undefined,
                desiredDomain: undefined,
                isPublished: false,
                isPublishingActive: true,
                publishedAt: undefined,
            },
            appMetadata: {},
            analytics: undefined,
            userID: userData.id,
            zapierAPIKey: undefined,
            zaps: [],
            webhooks: [],
            quotas: undefined,
            grandfathering: undefined,
            // This is only fine because we're making a brand new app.
            serial: 0,
        });

        dontAwait(this.props.loadAppAnalyticsForApp(appID));
        dontAwait(this.props.loadZapierAPIKeyForApp(appID));
        this.props.history.push(routes.app(appID));

        if (
            getGoogleSheetsSourceMetadata(sourcePad.sourceMetadata)?.fromSharedDrive === true &&
            organizationID === undefined
        ) {
            if (await showSharedDriveNeedsProModal()) {
                await showUpgradeModal(this.props.modals, "google shared drive", appID, true);
            }
        }
        // This shouldn't technically be necessary, since this is a new app,
        // but it also won't hurt.
        clearUndo(appID);

        trackEvent("new app created", {
            app_id: appID,
            data_source: "gsheet",
            preferredFormFactor: preferredFormFactor,
        });
    }

    private async chooseSheet(
        org: Organization | undefined,
        appName: string | undefined,
        newAppSurveyData: NewAppSurveyData,
        appKind: AppKind
    ): Promise<void> {
        this.setState({ creatingAppText: "Creating app…" });
        this.terribleHackToSetAppKind = appKind;
        try {
            // `chooseSheet` will eventually call `setSheetSource` above, if a sheet
            // is picked.
            const appIDorErrorMessage = await this._googleSheetsSource.chooseSheet(org?.id, newAppSurveyData, appName);

            if (appIDorErrorMessage === "cancel" || appIDorErrorMessage === undefined || isAppID(appIDorErrorMessage)) {
                if (isAppID(appIDorErrorMessage) && appName !== undefined) {
                    this.props.setAppTitle(appIDorErrorMessage.appID, appName);
                }
                return;
            }

            const errorMessage = appIDorErrorMessage;

            if (isSheetSourceSignInFailure(errorMessage)) {
                const {
                    underlying: { kind },
                } = errorMessage;
                if (kind === "declined-sign-in") return;
                if (kind === "popup-blocked") {
                    const onFinished = async (canceled: boolean) => {
                        if (!canceled) {
                            // Even though auth2 can be undefined in general, if we
                            // get to this code path auth2 had to be defined in the first place.
                            // @ts-ignore
                            const auth: gapi.auth2.GoogleAuth = await getAuth2();
                            if (!auth.isSignedIn.get()) return;
                            await this.chooseSheet(org, appName, newAppSurveyData, appKind);
                        }
                    };

                    showSignUpPopupBlockedFlow(this.props.modals.showModal, onFinished);
                } else if (kind === "no-google-libraries") {
                    await this.props.modals.showSimpleInfoModal(
                        "There's a problem",
                        <ModalBody>{googleConnectionFailureMessage}</ModalBody>
                    );
                } else if (kind === "unexpected-error") {
                    await this.props.modals.showSimpleInfoModal(SignInError.title, SignInError.bodyContent);
                } else if (kind === "cookies-blocked") {
                    await this.showThirdPartyCookiesModal();
                } else if (kind === "link-expired") {
                    await this.props.modals.showSimpleInfoModal(
                        "Authentication Link Expired",
                        "The given authentication link has expired."
                    );
                } else {
                    assertNever(kind);
                }
            } else {
                await this.props.modals.showSimpleInfoModal(
                    GenericOhSheetError(errorMessage.underlying).title,
                    GenericOhSheetError(errorMessage.underlying).bodyContent
                );
            }
        } catch (e: unknown) {
            if (isSizeLimitException(e)) {
                await showBasicActionModal(
                    "That's a lot of data.",
                    "Right now app data is limited to 1MB. We know, that’s less than floppy disk ;) We’ll fix it soon.",
                    "OK"
                );
            }
        } finally {
            this.setState({ creatingAppText: undefined });
            this.terribleHackToSetAppKind = AppKind.App;
        }
    }

    private async showNewItems(): Promise<void> {
        const userData = this.props.userData;
        if (userData === null || userData === "loading") return;
        this.setState({ shownLatest: true });

        const db = getBuilderUserDatabase(userData.id);

        const newFeatures = await loadNewFeatures(db, userData.id);
        logInfo(newFeatures);
        if (newFeatures === "never seen") {
            await saveNewestFeatureSeen(db, userData.id);
            return;
        } else if (newFeatures.length > 0) {
            await saveNewestFeatureSeen(db, userData.id);
        } else {
            return;
        }

        dontAwait(
            this.props.modals.showModal<void>(resolve => {
                return (
                    <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={resolve}>
                        <WhatsNewModal updates={newFeatures} />
                    </WindowedModalV2>
                );
            })
        );
    }

    private async showSignUpModal(): Promise<boolean> {
        const didSignIn = await this.props.modals.showModal<boolean>(resolve => {
            return (
                <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={() => resolve(false)}>
                    <SignInUpModal onFinish={canceled => resolve(!canceled)} />
                </WindowedModalV2>
            );
        });

        return didSignIn;
    }

    private async callDuplicateAppAndSetScreen(
        appID: string,
        organizationID: string | undefined,
        copySheet: boolean,
        fromTemplate: boolean
    ): Promise<void> {
        try {
            const body: DuplicateAppBody = { appID, copySheet, fromTemplate };
            const response = await getAppFacilities().callAuthCloudFunction("duplicateApp", body);
            if (!isResponseOK(response)) {
                const message = await getResponseErrorMessage(response);
                await this.props.modals.showSimpleInfoModal(
                    AppDuplicationError(message).title,
                    AppDuplicationError(message).bodyContent
                );
                return;
            }
            const { appID: copyAppID } = await response.json();
            this.props.addAppToOwner(copyAppID, organizationID);
            this.props.history.push(routes.app(copyAppID));
        } catch (e: unknown) {
            logError(`Duplicating app: ${e}`);
            await this.props.modals.showSimpleInfoModal(AppDuplicationError().title, AppDuplicationError().bodyContent);
        }
    }

    private showSubscriptionTransferWarning = async (
        transferToOrgAs: TransferToOrgAs,
        planName: string,
        orgName: string
    ): Promise<boolean> => {
        let confirm = true;
        if (transferToOrgAs === "public" || transferToOrgAs === "internal") {
            confirm = await this.props.modals.showAcceptCancelModal(
                `Transfer ${planName} app to ${orgName}?`,
                `Your app's ${planName} subscription will be cancelled and you'll receive credit for unused time. A new subscription will start under ${orgName}, and ${orgName} will billed for this app from now on.`,
                "Transfer"
            );
        }
        return confirm;
    };

    private transferAppToOrganization = async (appID: string, org: Organization): Promise<void> => {
        const tile = this.getAppTile(appID);
        if (tile === undefined) return;

        this.props.unloadApps([appID]);

        this.setState({ actionStatus: ActionStatus.Loading });

        try {
            const v = getAppOwner(appID, this.props.userData, this.props.organizations);
            if (v === undefined) return;
            const eminence = getAppEminenceFlags(v, appID, undefined);

            if (eminence.transferToOrgAs !== "free") {
                const charge = await previewCharge({
                    organizationID: org.id,
                });

                this.setState({ actionStatus: ActionStatus.Idle });

                const cardState = getCardState(charge?.monthly?.cardPreview);
                // this is a bad way to check
                if (cardState !== CardState.CardPresent) {
                    const goPay = await this.props.modals.showAcceptCancelModal(
                        "Cannot transfer",
                        "The target organization currently has no payment method to accept this app. Would you like to enter payment info?",
                        "Yes"
                    );
                    if (goPay) {
                        this.props.history.push(routes.billing(org.id));
                    }
                    return;
                }
            }

            const unconfirmedResult = await transferAppToOrganization(appID, org.id, false, false);
            if (unconfirmedResult === undefined) return;

            const eminenceFlags = this.getEminenceFlags(appID);
            const { transferToOrgAs, displayName } = eminenceFlags;
            if (transferToOrgAs === undefined) {
                this.setState({ actionStatus: ActionStatus.Idle });
                await this.props.modals.showSimpleInfoModal(
                    "Cannot transfer",
                    <ModalBody>This app cannot be transferred to a team.</ModalBody>
                );
                return;
            }

            if (eminenceFlags.eminence === Eminence.Pro) {
                this.setState({ actionStatus: ActionStatus.Idle });
                await this.props.modals.showSimpleInfoModal(
                    "Cannot transfer",
                    <ModalBody>
                        Legacy Pro apps cannot be transferred to teams. We recommend duplicating your app to create a
                        free copy, and transferring the copy.
                    </ModalBody>
                );
                return;
            }

            let asPublicApp = false;
            this.setState({ actionStatus: ActionStatus.Idle });
            switch (unconfirmedResult) {
                case TransferAppToOrganizationResponse.ErrorCannotTransferOrgApp:
                    await this.props.modals.showSimpleInfoModal(
                        "Team apps cannot be transferred to other teams",
                        <ModalBody>An app that's already in a team cannot be transferred to a team.</ModalBody>
                    );
                    return;

                case TransferAppToOrganizationResponse.ConfirmTransferUnpublished:
                    if (
                        !(await this.props.modals.showAcceptCancelModal(
                            "Are you sure you want to transfer this app?",
                            `Members of ${org.displayName} will be able to edit your app and access its sheet.`,
                            "Transfer"
                        ))
                    )
                        return;
                    if (!(await this.showSubscriptionTransferWarning(transferToOrgAs, displayName, org.displayName)))
                        return;
                    break;

                case TransferAppToOrganizationResponse.ErrorCannotTransferPublishedToFree:
                    await this.props.modals.showSimpleInfoModal(
                        "Your team must be on a paid plan",
                        <ModalBody>{`The team '${org.displayName}' must be upgraded to a paid plan before transferring published apps. Please upgrade it in your team billing settings first.`}</ModalBody>
                    );

                    return;
                case TransferAppToOrganizationResponse.ErrorCannotTransferPaidToFreeOrg:
                    await this.props.modals.showSimpleInfoModal(
                        "Your team must be on a paid plan",
                        <ModalBody>{`The team '${org.displayName}' must have a payment method on file to transfer a paid app. Please enter a payment method by going to the team's Billing section and selecting either Create Payment Method, or Customer Portal, at the top of the billing screen. You can also duplicate the app to create a free copy, and transfer the copy to the team.`}</ModalBody>
                    );
                    return;

                case TransferAppToOrganizationResponse.ConfirmTransferPublished:
                    if (
                        !(await this.props.modals.showAcceptCancelModal(
                            "Are you sure you want to transfer this app?",
                            `Members of ${org.displayName} will be able to edit your app and access its sheet.`,
                            "Transfer"
                        ))
                    )
                        return;
                    if (!(await this.showSubscriptionTransferWarning(transferToOrgAs, displayName, org.displayName)))
                        return;
                    asPublicApp = transferToOrgAs === "public";
                    break;

                case TransferAppToOrganizationResponse.ErrorCannotTransferTemplateBasedApp:
                    await this.props.modals.showSimpleInfoModal(
                        "Template apps cannot be transferred",
                        <ModalBody>
                            This app is based on a template and cannot be transferred. Please purchase the template as a
                            member of team, so the team owns a copy of the template.
                        </ModalBody>
                    );
                    return;

                default:
                    await this.props.modals.showSimpleInfoModal(TransferAppError.title, TransferAppError.bodyContent);
                    return;
            }

            const confirmedResult = await transferAppToOrganization(appID, org.id, true, asPublicApp);
            if (confirmedResult === undefined) {
                this.props.addAppToOwner(appID, org.id);
            } else {
                this.setState({ actionStatus: ActionStatus.Idle });
                await this.props.modals.showSimpleInfoModal(TransferAppError.title, TransferAppError.bodyContent);
            }
        } finally {
            this.setState({ actionStatus: ActionStatus.Idle });
        }
    };

    private transferAppToUser = async (appID: string, withCopy: boolean): Promise<void> => {
        const maybeEmail = await this.props.modals.showModal<string | false>(resolve => {
            return (
                <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={() => resolve(false)}>
                    <InviteUserToAppModal onCompletion={resolve} withCopy={withCopy} />,
                </WindowedModalV2>
            );
        });

        if (maybeEmail === false) return;

        const body: InviteUserToTransferAppBody = { appID, recipientEmail: maybeEmail, withCopy };
        const result = await getAppFacilities().callAuthCloudFunction("inviteUserToTransferApp", body);
        if (result?.ok === undefined || !result.ok) {
            await this.props.modals.showSimpleInfoModal(InviteUserError.title, InviteUserError.bodyContent);
            return;
        }

        await this.props.modals.showSimpleInfoModal(
            "Success!",
            <ModalBody>We sent an invite to {maybeEmail}!</ModalBody>
        );
    };

    private makeSupportCode = async (appID: string): Promise<void> => {
        const body: MakeSupportCodeForAppBody = { appID };
        const response = await getAppFacilities().callAuthCloudFunction("makeSupportCodeForApp", body);
        if (!isResponseOK(response)) {
            await this.props.modals.showSimpleInfoModal(
                SupportLinkCreateError.title,
                SupportLinkCreateError.bodyContent
            );
            return;
        }
        const { url } = await response.json();

        await this.props.modals.showModal<void>(resolve => {
            return <SupportModal closeModal={resolve} appLink={checkString(url)} />;
        });
    };

    private ensureConfirmedProUpgrades(): void {
        // This works as well as it does because we only register a need to confirm Pro upgrades
        // when the Pro upgrade is requested. Incumbent Pro subscriptions aren't registered,
        // so 'confirming' them is a no-op.
        const { userData } = this.props;
        if (!isUserData(userData)) return;

        for (const appID of userData.planAppIDs.pro) {
            confirmProUpgrade(appID);
        }
    }

    public async componentDidMount(): Promise<void> {
        const queryStringParsed = queryString.parse(window.location.search.substr(1));

        // The firebase auth token can come lowercased or camelCased.
        const {
            stripeConnectFailed,
            firebaseAuthToken: camelCaseAuthToken,
            firebaseauthtoken: lowercaseAuthToken,
        } = queryStringParsed;

        const firebaseAuthToken = camelCaseAuthToken ?? lowercaseAuthToken;

        if (firebaseAuthToken !== undefined) {
            // This path generally should not be used for authentication.
            // We only added this to get past Google Auth in end to end testing,
            // since Google Auth doesn't like to be invoked from scripted browsers.
            // NOTE: We have two location where we look for query strings, and then
            // remove all of them.  The other one's in `GlideDesigner/index.tsx`.
            const firebaseAuthTokenString = checkString(firebaseAuthToken);
            signInToFirebaseWithCustomToken(firebaseAuthTokenString).catch(e => {
                logError(`Could not sign in to Firebase with custom token: ${e}`);
            });
        }

        removeQueryStrings("stripeConnectFailed", "signIn", "signUp", "firebaseAuthToken");

        this.ensureConfirmedProUpgrades();

        if (stripeConnectFailed !== undefined) {
            return await showBasicActionModal(
                "There was an error connecting to Stripe",
                "This often occurs when your Internet connection is unreliable. Please check your connection and try again.",
                "OK"
            );
        }

        const { copyApp } = queryStringParsed;

        if (copyApp === undefined) return;

        const copyAppID = Array.isArray(copyApp) ? copyApp[0] : copyApp;

        const doCopy = once(async () => {
            const { shouldPerformCopy } = this.state;
            if (!shouldPerformCopy) return;

            logInfo(`Copying app ${copyApp}`);
            trackEvent("copy user template", { app_id: copyAppID });
            await this.callDuplicateAppAndSetScreen(checkString(copyApp), undefined, true, true);
            this.setState({ shouldPerformCopy: false, actionStatus: ActionStatus.Idle });
        });

        // Heads up: there's a little bit of a race with showSignUpModal.
        //
        // If it returns "true", doCopy() will _actually_ have run before the return.
        // This is fine, except that means we can't set the actionStatus to Loading afterwards.
        // If it returns "false", then doCopy() won't have run yet, but we need to ensure
        // that actionStatus is Idle.
        const doShowModal = once(async () => {
            let { shouldPerformCopy } = this.state;
            if (!shouldPerformCopy) return;

            shouldPerformCopy = await this.showSignUpModal();
            if (shouldPerformCopy) {
                trackEvent("sign up for copying user template", { app_id: copyAppID });
                this.setState({ shouldPerformCopy });
            } else {
                this.setState({ shouldPerformCopy, actionStatus: ActionStatus.Idle });
            }
        });

        this.setState({ shouldPerformCopy: true, actionStatus: ActionStatus.Loading });
        onAuthStateChanged(async auth => {
            if (auth !== undefined && parseAnonymousUserID(auth.uid) === undefined) {
                await doCopy();
            } else {
                await doShowModal();
            }
        });
    }

    public async componentDidUpdate(): Promise<void> {
        this.ensureConfirmedProUpgrades();
        if (this.state.shownLatest || this.props.userData === "loading" || this.props.userData === null) return;
        await this.showNewItems();
    }

    private newApp = async (
        org: Organization | undefined,
        appName: string | undefined,
        newAppSurveyData: NewAppSurveyData,
        appKind: AppKind
    ): Promise<void> => {
        if (getLocationSettings().showBetaWarning) {
            if (
                !(await this.props.modals.showInfoActionModal(
                    "Disclaimer",
                    "Staging is only meant for testing Glide and previewing new features early.  It is less stable than the later versions officially released to the public. Use it only for non-production apps that aren’t critical. Your apps might break or even get deleted.",
                    "Ok, I got it",
                    "Get me to proper Glide!"
                ))
            ) {
                window.location.href = "https://go.glideapps.com";
                return;
            }
        }

        this.setState({ actionStatus: ActionStatus.Loading });

        await this.chooseSheet(org, appName, newAppSurveyData, appKind);

        this.setState({ actionStatus: ActionStatus.Idle });
    };

    private newGlideTableApp = async (
        org: Organization | undefined,
        appName: string | undefined,
        newAppSurveyData: NewAppSurveyData
    ): Promise<void> => {
        logInfo(org);

        try {
            startBusy();

            const body: NewGlideTableAppBody = {
                overrides: makeRandomAppSettings(
                    appName ?? "My App",
                    org !== undefined
                        ? {
                              kind: AppAuthenticationKind.EmailPin,
                              source: AuthenticationEmailSource.OrgMembers,
                          }
                        : undefined
                ),
                ownerID: org?.id,
                ...newAppSurveyData,
            };
            const result = await getAppFacilities().callAuthCloudFunction("newGlideTableApp", body);
            if (!isResponseOK(result)) {
                const message = await getResponseErrorMessage(result);
                dontAwait(
                    this.props.modals.showModal<void>(resolve => {
                        return (
                            <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={resolve}>
                                <ActionModal header="Couldn't make app" description={message} acceptText="OK" />
                            </WindowedModalV2>
                        );
                    })
                );
                return;
            }

            const { appID } = await result.json();
            trackEvent("new app created", {
                app_id: appID,
                data_source: "glide",
                preferredFormFactor: newAppSurveyData.formFactor,
            });
            this.props.history.push(routes.app(checkString(appID)));
        } finally {
            stopBusy();
        }
    };

    private getAppTile(appID: string): TileDescription | undefined {
        const apps = this.props.tiles;
        const app = apps[appID];
        if (app !== "loading" && app !== undefined) {
            return app;
        } else {
            return undefined;
        }
    }

    private duplicateAppFull = async (appID: string, organizationID: string | undefined): Promise<void> => {
        const tile = this.getAppTile(appID);
        if (tile === undefined) return;

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.duplicateApp(
            appID,
            organizationID,
            tile.title,
            <Icon size={32} clipCorners={true} color={tile.primaryAccentColor} image={tile.iconImage} />
        );
    };

    private duplicateApp = async (
        appID: string,
        organizationID: string | undefined,
        appTitle: string,
        appIcon: JSX.Element
    ): Promise<void> => {
        this.setState({ creatingAppText: "Duplicating app and sheet…", actionStatus: ActionStatus.Loading });
        const method = await this.props.modals.showModal<DuplicateMethod>(resolve => {
            return (
                <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={() => resolve("dont")}>
                    <DuplicateAppModal appID={appID} appTitle={appTitle} appIcon={appIcon} onSelection={resolve} />
                </WindowedModalV2>
            );
        });
        if (method === "dont") {
            this.setState({ creatingAppText: undefined, actionStatus: ActionStatus.Idle });
            return;
        }
        trackEvent("duplicate app", { app_id: appID, method });
        const copySheet = method === "new-sheet";
        await this.callDuplicateAppAndSetScreen(appID, organizationID, copySheet, false);
        this.setState({ creatingAppText: undefined, actionStatus: ActionStatus.Idle });
    };

    private goToSelfBilling = () => {
        this.props.history.push("/o/0/billing");
    };

    private deleteApp = async (appID: string, title: string): Promise<void> => {
        const { userData, organizations: orgs } = this.props;
        const owner = getAppOwner(appID, userData, orgs);
        if (
            await this.props.modals.showAcceptCancelModal(
                `Delete ${title}?`,
                `Your app will be permanently deleted. This cannot be undone.`,
                "Delete"
            )
        ) {
            this.setState({ actionStatus: ActionStatus.Loading });
            try {
                const response = await getAppFacilities().callAuthCloudFunction("deleteApp", { appID });
                if (isResponseOK(response)) {
                    if (owner?.kind === OwnerKind.User) {
                        this.props.removeAppFromUser(appID);
                    } else if (owner?.kind === OwnerKind.Organization) {
                        this.props.removeAppFromOrganization({ orgID: owner.id, appID });
                    }
                    clearUndo(appID);
                    this.props.unloadApps([appID]);
                    this.setState({ actionStatus: ActionStatus.Idle });
                    return;
                }

                if (response?.status === 400) {
                    const responseJSON = await response.json();
                    if (hasOwnProperty(responseJSON, "reason") && responseJSON.reason === "still-pro") {
                        if (
                            (await this.props.modals.showAcceptCancelModal(
                                `'${title}' is still Pro`,
                                `Downgrade ${title}' or transfer its subscription in the Billing section before deleting it.`,
                                "Go to Billing"
                            )) &&
                            owner !== undefined
                        ) {
                            this.goToSelfBilling();
                        }
                        return;
                    }
                }

                throw new Error("Could not unpublish");
            } catch (e: unknown) {
                const body: MakeSupportCodeForAppBody = { appID };
                const response = await getAppFacilities().callAuthCloudFunction("makeSupportCodeForApp", body);
                let supportLink = "";
                if (isResponseOK(response)) {
                    const { url } = await response.json();
                    supportLink = url;
                }

                this.setState({ actionStatus: ActionStatus.Idle });
                await this.props.modals.showSimpleInfoModal(
                    UnpublishDeleteAppError(supportLink).title,
                    UnpublishDeleteAppError(supportLink).bodyContent
                );
                return;
            }
        }
    };

    private onNewUser = once(async (joinOrg?: boolean): Promise<void> => {
        const orgID = this.props.match.params.orgID;
        if (isUserData(this.props.userData)) {
            const userID = this.props.userData.id;
            const userData: UserData = this.props.userData;
            await this.props.modals.showModal<void>(resolve => {
                return (
                    <WindowedModalV2 canClose={false} hideClosingButton={true} onClose={resolve} padding={0}>
                        <OnboardingStyle headerChinPadding={8}>
                            {joinOrg ? (
                                <AcceptTeamInvite orgID={orgID} userData={userData} onDone={resolve} />
                            ) : (
                                <OnBoarding orgID={orgID} userID={userID} onDone={resolve} />
                            )}
                        </OnboardingStyle>
                    </WindowedModalV2>
                );
            });

            this.props.history.replace(routes.org(orgID));

            const results = await Promise.all([
                await handleFirstTermsOfService(
                    this.props.userData,
                    this.props.setLastAcceptedTermsOfService,
                    this.props.signOut,
                    true
                ),
                await finishOnboarding({ organizationID: orgID }),
            ]);
            if (results[1]?.ok) {
                this.props.setUserFlags(this.props.userData, { onboardingComplete: true });
            }
        }
    });

    public render() {
        const { userData, match } = this.props;
        if (browserOnPhone) {
            return <MobileOverviewScreen />;
        }

        if (isUserData(userData)) {
            const noMyApps = userData.appIDs.length === 0 && userData.orgUserIDs.length > 0;
            const shouldRedirect = noMyApps && match.params.orgID === "0";

            if (shouldRedirect) {
                return <Redirect to={routes.org(userData.orgUserIDs[0])} />;
            }
        }

        const overviewScreen = (p: RouteComponentProps<any>) => (
            <OverviewScreen
                {...p}
                onDeleteApp={this.deleteApp}
                onNewApp={this.newApp}
                onNewGlideTableApp={this.newGlideTableApp}
                onDuplicateApp={this.duplicateAppFull}
                onTransferAppToOrganization={this.transferAppToOrganization}
                onTransferAppToUser={this.transferAppToUser}
                onMakeSupportCode={this.makeSupportCode}
                onNewUser={this.onNewUser}
            />
        );

        const sw = (
            <Switch>
                <Route exact={true} path={routes.orgBillingPattern} component={BillingScreen} />
                <Route exact={true} path={routes.orgReferralPattern} component={ReferralScreen} />
                <Route exact={true} path={routes.orgMembersPattern} component={MembersScreen} />
                <Route
                    exact={true}
                    path={[
                        routes.overview,
                        routes.orgPattern,
                        routes.dataRightsPattern,
                        routes.orgNewApp,
                        routes.newRoute,
                    ]}
                    render={overviewScreen}
                />
                <Redirect to="/" />
            </Switch>
        );

        return (
            <OrgsScreen
                loading={this.state.actionStatus === ActionStatus.Loading}
                startingMode={this.forceSignInMode ? "signIn" : undefined}>
                {sw}
            </OrgsScreen>
        );
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
    organizations: state.organizations,
    apps: state.apps,
    tiles: state.tiles,
});

const mapDispatch = {
    setApp: appsActions.setApp,
    addAppToOwner: actions.addAppToOwner,
    removeAppFromUser: userReducer.deleteApp,
    removeAppFromOrganization: organizations.removeAppFromOrganization,
    unloadApps: appsActions.unloadApps,
    loadAppAnalyticsForApp: actions.loadAppAnalyticsForApp,
    loadZapierAPIKeyForApp: actions.loadZapierAPIKeyForApp,
    setUserFlags: actions.setUserFlags,
    setLastAcceptedTermsOfService: userActions.setLastAcceptedTermsOfService,
    setAppTitle: actions.setAppTitle,
    signOut: actions.signOut,
};

export default withModalProvider(withRouter(connect(mapState, mapDispatch)(Apps)));
